var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.53 11.3501L12.59 5.42012C12.5013 5.32361 12.3919 5.2484 12.27 5.20012C12.1498 5.14888 12.0207 5.1217 11.89 5.12012C11.756 5.12037 11.6233 5.14758 11.5 5.20012C11.3781 5.2484 11.2687 5.32361 11.18 5.42012L5.24 11.3501C5.0517 11.5384 4.94591 11.7938 4.94591 12.0601C4.94591 12.3264 5.0517 12.5818 5.24 12.7701C5.4283 12.9584 5.6837 13.0642 5.95 13.0642C6.2163 13.0642 6.4717 12.9584 6.66 12.7701L10.89 8.54012V18.0001C10.89 18.2653 10.9954 18.5197 11.1829 18.7072C11.3704 18.8948 11.6248 19.0001 11.89 19.0001C12.1552 19.0001 12.4096 18.8948 12.5971 18.7072C12.7846 18.5197 12.89 18.2653 12.89 18.0001V8.54012L17.12 12.7701C17.3063 12.9549 17.5577 13.059 17.82 13.0601C17.9516 13.0609 18.0821 13.0357 18.2039 12.9859C18.3257 12.9361 18.4366 12.8628 18.53 12.7701C18.6237 12.6772 18.6981 12.5666 18.7489 12.4447C18.7997 12.3228 18.8258 12.1921 18.8258 12.0601C18.8258 11.9281 18.7997 11.7974 18.7489 11.6755C18.6981 11.5537 18.6237 11.4431 18.53 11.3501Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUp);
export default __webpack_public_path__ + "static/media/IconArrowUp.f7b35bb054590f334f150339aa83d9ac.svg";
export { ForwardRef as ReactComponent };